import {useEffect,useState} from 'react'
import {contentRequest} from '../../../packages/content-client/src'

/** No cached counts or names survive an authority refresh or a failed request. */
export default function ReviewNotifications(){
 const [items,setItems]=useState<{project_id:string;project_name:string;count:number;url:string}[]>([])
 useEffect(()=>{
  let active:AbortController|null=null
  const refresh=()=>{if(document.hidden)return;active?.abort();const c=new AbortController();active=c;setItems([]);void contentRequest<{notifications:typeof items}>('/knowledge/project-context/notifications/inbox',{signal:c.signal}).then(v=>{if(!c.signal.aborted)setItems(v.notifications)}).catch(()=>{})}
  refresh();const timer=setInterval(refresh,15000);window.addEventListener('focus',refresh)
  return()=>{active?.abort();clearInterval(timer);window.removeEventListener('focus',refresh)}
 },[])
 return items.length?<section aria-label="Review notifications"><h2>Work needs review</h2>{items.map(item=><p key={item.project_id}><a href={item.url}>{item.project_name} · {item.count} source change {item.count===1?'review':'reviews'}</a></p>)}</section>:null
}
